import React from 'react'
import { Container, Button, SegmentedButton } from '@sencha/ext-modern'

import { getMixedProps } from './blockPublic'

const FormSegmentedButton = ({ field, onChange, defaultStyle }) => {
	const { props: { handler, selected, value, items, ...props } } = getMixedProps('_segmentedButton', [defaultStyle, field])

	const handleChange = (obj, newValue) => {
		handler ? handler(newValue) : onChange({ newValue })
	}

	return <Container {...props} {...{ errorTarget: undefined }}>
		<SegmentedButton defaultUI="toolbar-default" value={selected || value} onChange={handleChange}>
			{items.map((item, i) => {
				const [text, value] = Array.isArray(item) ? item : [item]
				return <Button key={`${value}_${i}`} text={text} value={value || text} />
			})}
		</SegmentedButton>
	</Container>
}

const renderSegmentedButton = config => {
	const { key } = config.field || {}
	return <FormSegmentedButton key={key} {...config} />
}

export default renderSegmentedButton